(() => {
  const initialize = () => {
    const switches = document.querySelectorAll('[data-be-language]');
    let language = 'en';
    try { language = sessionStorage.getItem('be-home-language') === 'es' ? 'es' : 'en'; } catch {}
    const translate = (next) => {
      language = next === 'es' ? 'es' : 'en';
      document.querySelectorAll('[data-be-copy]').forEach(node => {
        node.textContent = node.getAttribute(`data-be-${language}`);
        node.lang = language;
      });
      document.querySelectorAll('[data-be-label-en]').forEach(node => {
        node.setAttribute('aria-label', node.getAttribute(`data-be-label-${language}`));
      });
      document.querySelectorAll('[data-be-placeholder-en]').forEach(node => {
        node.placeholder = node.getAttribute(`data-be-placeholder-${language}`);
      });
      switches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.beLanguage === language)));
      document.querySelectorAll('.be-redesign').forEach(node => node.lang = language);
      try { sessionStorage.setItem('be-home-language', language); } catch {}
    };
    switches.forEach(button => {
      button.hidden = false;
      if (!button.dataset.beBound) {
        button.addEventListener('click', () => translate(button.dataset.beLanguage));
        button.dataset.beBound = 'true';
      }
    });
    translate(language);
    const nav = document.querySelector('[data-be-nav]');
    const wide = matchMedia('(min-width: 1000px)');
    if (nav && !nav.dataset.beBound) {
      const sizeNav = () => nav.open = wide.matches;
      sizeNav();
      wide.addEventListener('change', sizeNav);
      nav.dataset.beBound = 'true';
    }
    document.querySelectorAll('[data-be-submenu]').forEach(details => {
      if (details.dataset.beBound) return;
      details.addEventListener('toggle', () => {
        if (details.open) document.querySelectorAll('[data-be-submenu]').forEach(other => {
          if (other !== details) other.open = false;
        });
      });
      details.dataset.beBound = 'true';
    });
  };
  initialize();
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    const card = link?.closest('[data-be-merchandise]');
    if (!card?.dataset.beProductHandle || window.Shopify?.designMode) return;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    try {
      Promise.resolve(publish.call(window.Shopify.analytics, 'bakers_express:homepage_product_click', {
        product_handle: card.dataset.beProductHandle,
        product_id: card.dataset.beProductId || null,
        section: card.dataset.beMerchandise,
        project: card.dataset.beProject || null,
        language: document.querySelector('.be-redesign')?.lang || 'en',
        destination: link.getAttribute('href')
      })).catch(() => {});
    } catch {}
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="view=be-project-"]');
    if (!link || window.Shopify?.designMode) return;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    try {
      Promise.resolve(publish.call(window.Shopify.analytics, 'bakers_express:project_click', {
        destination: link.getAttribute('href'),
        language: document.querySelector('.be-redesign')?.lang || 'en'
      })).catch(() => {});
    } catch {}
  });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-be-submenu][open]').forEach(node => {
      node.open = false;
      node.querySelector('summary').focus();
    });
  });
})();
